import { render, staticRenderFns } from "./CampaignStats.vue?vue&type=template&id=1ecf5def&"
import script from "./CampaignStats.vue?vue&type=script&lang=js&"
export * from "./CampaignStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ecf5def')) {
      api.createRecord('1ecf5def', component.options)
    } else {
      api.reload('1ecf5def', component.options)
    }
    module.hot.accept("./CampaignStats.vue?vue&type=template&id=1ecf5def&", function () {
      api.rerender('1ecf5def', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/rd/CampaignStats.vue"
export default component.exports